/**
 * A running duration, as the pit wall reads it: m:ss, growing an hours field
 * only once there is one. Used for time in the box and time on track.
 */
export function formatElapsed(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
}

/**
 * Apex's own pit stopwatch, in seconds, or null when the kart is not in the pit.
 *
 * Two different clocks come down the same `otr` cell, told apart only by a
 * trailing dot: dotted is the pit stopwatch (`32.`, `2:16.`), undotted is stint
 * age (`1:23`). Checked against 200k samples of a recorded event — dotted is
 * inBox 99.2% of the time, undotted is on-track 98.6%.
 *
 * Preferred over timing the pit ourselves from the *in transition, because it
 * is the track's own clock: it is right even when we connected mid-stop and
 * never saw the kart go in, which is when our own timer has nothing to count
 * from. The `to` channel looks like it should carry this, but the recorded
 * event has it empty in every in-pit sample.
 */
export function apexPitSeconds(onTrackTime: string | undefined): number | null {
  const raw = (onTrackTime ?? '').trim();
  if (!raw.endsWith('.')) return null;

  const parts = raw.slice(0, -1).split(':');
  if (parts.length > 3) return null;

  let seconds = 0;
  for (const part of parts) {
    if (!/^\d+$/.test(part)) return null;
    seconds = seconds * 60 + Number(part);
  }
  return seconds;
}
